import styled from 'styled-components';

export const LoginGrowMainWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        align-items: center;
        justify-content: space-between;

        @media(max-width:1023px){
            flex-direction: column;
        }
    `
)